<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-02 17:41:17
 * @LastEditors: 诺
 * @LastEditTime: 2022-01-17 18:15:12
 * @Description: file content
 如是分享引导页 很多客风格
 -->
<template>
  <div class="container" v-show="value">
    <!-- <div class="share_mask" @click="clickClose" :class="{'txt-center': message.txtStatus === 'center'}">
      <div class="share_line">
        <span></span>
        <img src="https://assets.rurushishi.com/activies/mfAct/sharelight.png" alt />
      </div>
      <div v-if="message.text0" class="txt0">{{message.text0}}</div>
      <div class="txt1">
        <span v-if="message.text1">{{message.text1}}</span>
        <span v-if="message.text2" class="txt1_span">{{message.text2}}</span>
        <span v-if="message.text3">{{message.text3}}</span>
      </div>
      <div v-if="message.text4" class="txt2">{{message.text4}}</div>
      <div v-if="message.text5" class="txt3">{{message.text5}}</div>
      <div v-if="message.text6" class="txt4">{{message.text6}}</div>
      <img
        class="tray"
        src="https://assets.rurushishi.com/yq-rs-make/components/share_guide3/tray.png"
        alt
      />
      <div class="saveimg" @click.stop="onSave">存图分享，一样有惊喜</div>
    </div> -->
    <div class="share" @click="clickClose">
      <img class="shareImg" :src="`https://assets.rurushishi.com/activies/activityCenter/${$setting.imgDir}/shareImg.png`" />
      <div class="saveimg" @click.stop="onSave">
        <img class="img" src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/icon.png" />
        存图分享，一样有惊喜
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    myProp: {},
  },
  data() {
    return {
      value: false,
      callback: null,
      message: "",
      // gameCount:"",
    };
  },
  watch: {},
  computed: {},
  methods: {
    clickClose: function () {
      this.value = false;
      this.callback("cancel");
    },
    //点击存图分享
    onSave: function () {
      this.value = false;
      // this.callback("onSave");
      this.callback("save");
    },
  },
  created() {
    // this.$wx.shareCallBackFunList.push("share1", () => {
    //   console.log("分享页面")
    //   this.$httpdf.post(this.$apidf.voice_hanlin.share).then(() => {
    //     this.value = false;
    //     this.callback("share")
    //   });
    // });
    // this.$httpdf
    //   .post(this.$apidf.help_on.share, {
    //     channel: this.$channel,
    //     openid: this.$openid,
    //     referenceOpenid: this.$fopenid,
    //     prizeCode: "prize_1"
    //   })
    //   .then(() => {
    //     this.value = false;
    //     this.callback("share");
    //   });
  },
  mounted() {},
};
</script>
<style lang="stylus" scoped>
.share_mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;

  &.txt-center {
    .txt1 {
      margin-left: -140px;
    }

    .txt2 {
      margin-left: -110px;
    }
  }
}

.share_mask .share_line {
  position: absolute;
  top: 0px;
  right: 0;
  z-index: 9;
  width: 275px;
}

.share_mask .share_line > span {
  width: 4px;
  height: 4px;
  border-radius: 30%;
  background-color: #fff;
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  display: inline-block;
  z-index: 8;
  -webkit-animation: sroll 3s infinite;
  animation: sroll 3s infinite;
}

.share_mask .share_line > img {
  width: 100%;
  animation: scaol 1.5s infinite;
}

@keyframes sroll {
  0% {
    transform: translate(0px, 0px);
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }

  100% {
    opacity: 0.3;
    transform: translate(180px, -200px);
  }
}

@keyframes scaol {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.05);
    opacity: 0.7;
  }

  80% {
    transform: scale(1.03);
    opacity: 0.75;
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.share_mask .txt0 {
  position: absolute;
  top: 270px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
  color: #fffdd2;
  font-size: 18px;
}

.share_mask .txt1 {
  position: absolute;
  top: 300px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
  color: #fffdd2;
  font-size: 16px;
  display: flex;
  align-items: baseline;

  span {
    white-space: nowrap;
    vertical-align: text-bottom;
  }
}

.share_mask .txt1 .txt1_span {
  font-size: 20px;
  color: #dddc68;
}

.share_mask .txt2 {
  position: absolute;
  top: 330px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
  color: #fffdd2;
  font-size: 16px;
}

.share_mask .txt3 {
  position: absolute;
  top: 360px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
  width: 100%;
  text-align: center;
  color: #fffdd2;
  font-size: 16px;
}

.share_mask .txt4 {
  position: absolute;
  top: 390px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
  width: 300px;
  color: #fffdd2;
  font-size: 16px;
  text-align: center;
}

.tray {
  position: absolute;
  top: 320px;
  left: 50%;
  margin-left: -170px;
  z-index: 9;
  width: 350px;
  color: #fffdd2;
  font-size: 16px;
  z-index: -1;
}

// .saveimg {
//   position: absolute;
//   bottom: 50px;
//   left: 50%;
//   margin-left: -100px;
//   z-index: 9;
//   padding: 10px 40px;
//   border-radius: 20px;
//   color: #fffdd2;
//   font-size: 12px;
//   border: 1px solid #f86e6f;
// }

.save-wrap {
  line-height: 40px;
  display: flex;
  font-size: 14px;
  border: 1px solid red;
}

.share {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;

  .shareImg {
    position: absolute;
    top: 0;
    right: 0;
    width: 300px;
  }

  .saveimg {
    position: absolute;
    top: 70%;
    width: 250px;
    padding:0 24px;
    height: 44px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(255, 255, 255, 0.1);
    border: 0.5px solid rgba(255, 255, 255, 0.5);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    text-align: center;
    color: #FFFFFF;
    border-radius: 22px;
    .img{
      width:19px;
      margin-right:12px;
    }
  }
}
</style>
